import { Component, Input } from '@angular/core';

import { GridData, CellComponent, CellContext } from '@grid/models';

@Component({
  selector: 'app-time-display',
  template: `<span
    [attr.data-testId]="
      'display-' + context.column.header.name + '-' + context.row.index
    "
    >{{ context.data[context.column.columnDef] | customTimeDisplay }}</span
  >`,
})
export class TimeDisplayComponent implements CellComponent<GridData> {
  @Input({ required: true }) context!: CellContext<GridData>;
}
